export default __webpack_public_path__ + "a78a0925d6073fa4a00ff0b46f9074f3.jpg";